// --- Live search ---	
var uxLiveSearch = function(item) {

	this.item = item;

	
	if(!this.hasOwnProperty('item')){
		
		return false;

	};


	this._init();

};


uxLiveSearch.prototype = {

	_init: function() {

		this.searchInput = this.item.querySelector('.live-search__input');
		this.searchItems = this.item.querySelectorAll('[data-live-search-item]');


		this._event();				

	},


	_event: function() {

		this.searchInput.addEventListener('input', this._event_search.bind(this), false);

	},


	_event_search: function() {

		let	itemValue = null,			 
			target = event.target,
			targetValue = target.value.toLowerCase();

		
		this.searchItems.forEach((item, index, array) => {

			itemValue = item.dataset.liveSearchItem.toLowerCase();
			
			if (itemValue.search(targetValue) < 0) {

				item.classList.add('hide');

			} else {
				
				item.classList.remove('hide');

			}	

		});			

	}

};


export  { uxLiveSearch };
// --- /Live search ---